import React from 'react';

const footer = () => (
  <footer className="footer">
    <p> Created By Andrew Chanthakoun 2024</p>
    <div className="social-links">
      <a href="https://www.linkedin.com/in/andrew-chanthakoun-0a94961a1/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
    </div>
  </footer>
);

export default footer;